
namespace RioERP.Orders {
    export class OrderTeacherShareCalculationColumns {
        static columnsKey = 'Orders.OrderTeacherShareCalculation';
    }
}